import CoachView from './CoachView';

export default CoachView;
